import { PropTypes } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";

interface IProps {
  name?: string;
  label?: string;
  error?: boolean;
  isLink?: boolean;
  helperText?: string;
  link?: { href: string; message: string };
  margin?: PropTypes.Margin;
  [property: string]: any;
}

export default function CustomTextField({
  margin,
  name,
  label,
  error,
  helperText,
  isLink,
  link,
  ...props
}: IProps) {
  return (
    <FormControl fullWidth margin={margin}>
      <InputLabel htmlFor={`CustomTextField-${name}`}>{label}</InputLabel>
      <Input
        {...props}
        name={name}
        id={`CustomTextField-${name}`}
        error={error}
      />
      {error && (
        <FormHelperText error>
          {helperText}
          {isLink && (
            <a
              href={`${link?.href}`}
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: 5 }}
            >{`${link?.message}`}</a>
          )}
        </FormHelperText>
      )}
    </FormControl>
  );
}
